<script lang="ts">
	import Button from "@components/common/Button.svelte";
	import Icon from "@components/common/Icon.svelte";
	import Link from "@components/common/Link.svelte";
	import type { HTMLAttributes } from "svelte/elements";
	import dropdownIcon from "@core/assets/icons/dropdown-arrrow.svg?raw";
	import { tenants } from "@core/config/tenants.js";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";

	const { tenant, pagePath } = getGlobalTemplateProps();
	const currentLocale = tenant.locale;
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	const otherTenants = Object.values(tenants).filter(({ locale }) => locale !== currentLocale);
	const div: HTMLAttributes<HTMLDivElement> = $props();
	const singleLocale = $derived(otherTenants.filter(({ locale }) => pagePath[locale] !== undefined).length === 0);
	let isLanguageListOpen = $state(false);
</script>

<div {...div} class={[div.class, "group relative text-cmctext", singleLocale && "hidden"]}>
	<Button
		icon="none"
		variant={ButtonVariant.Text}
		class="text-cmctext text-xs/tight font-semibold uppercase tracking-[0.125rem] transition-all duration-300 ease-in-out lg:rounded-lg lg:px-4 lg:py-2 hover:text-cmcprimary"
		onclick={(): void => {
			isLanguageListOpen = !isLanguageListOpen;
		}}
	>
		<span class="inline-flex gap-2 items-center">
			{currentLocale}
			<Icon
				icon={dropdownIcon}
				class={["h-2 group-hover:lg:rotate-180 duration-300 transition-transform ease-in-out"]}
			/>
		</span>
	</Button>
	<div
		class={[
			"absolute left-1/2 top-[calc(100%+.25rem)] w-[calc(100%+1rem)] -translate-x-1/2 rounded-lg bg-white shadow-sm transition-opacity duration-300 ease-in-out lg:after:absolute lg:after:-top-1 lg:after:left-0 lg:after:right-0 lg:after:h-1 lg:after:w-full lg:after:content-[''] lg:group-hover:pointer-events-auto lg:group-hover:opacity-100",
			isLanguageListOpen
				? "pointer-events-auto opacity-100 lg:pointer-events-none lg:opacity-0"
				: "pointer-events-none opacity-0 lg:pointer-events-none lg:opacity-0",
		]}
	>
		{#each otherTenants as tenant (tenant)}
			{@const link = pagePath[tenant.locale]}
			{#if link}
				<Link
					class="lg:text-3xs hover:text-cmcprimary !block w-full rounded-lg p-2 text-center text-xs font-semibold uppercase tracking-[0.125rem] transition-colors duration-300 ease-in-out hover:bg-gray-100 lg:font-normal"
					variant={ButtonVariant.Text}
					href={link}
					icon="none"
				>
					{tenant.locale}
				</Link>
			{/if}
		{/each}
	</div>
</div>
